<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/storeIntegrations/">Channels</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/storeConnections/">Create Channel</a></li>
      <li class="breadcrumb-item active" aria-current="page">Google Sheet</li>
    </ol>
  </nav>

  <div class="row">
    <div class="col">
      <div class="inner-box p-4">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="control-label">Channel Name</label>
              <input type="text" id="channelNameMagento" class="form-control" (blur)="channelNameBlur()"
                     [ngClass]="{'is-invalid':channelNameError}" [(ngModel)]="channelName"
                     [ngModelOptions]="{standalone: true}" placeholder="Channel name" required>
              <div id="channelNameError" class="invalid-feedback d-block shift-invalid-login"
                   [hidden]="!channelNameError"
                   style="position: absolute;">{{channelNameError}}
              </div>
            </div>
            <label class="control-label" for="password">Google SheetId</label>
            <input type="text" id="password" class="form-control" (blur)="googleSheetIdBlur()"
                   [ngClass]="{'is-invalid':googleSheetError}" [(ngModel)]="googleSheetId"
                   [ngModelOptions]="{standalone: true}"
                   placeholder="Google SheetId" required>
            <div id="googleSheetError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!googleSheetError"
                 style="position: absolute;">{{googleSheetError}}
            </div>

          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="control-label" for="name">Google Sheet Name</label>
              <input type="text" id="name" class="form-control" (blur)="googleSheetNameBlur()"
                     [ngClass]="{'is-invalid':googleSheetNameError}" [(ngModel)]="googleSheetName"
                     [ngModelOptions]="{standalone: true}"
                     placeholder="Google Sheet Name" required>
              <div id="googleSheetNameError" class="invalid-feedback d-block shift-invalid-login"
                   [hidden]="!googleSheetNameError"
                   style="position: absolute;">{{googleSheetNameError}}
              </div>
            </div>

          </div>

          <div class="col-md-3 align-self-end">
            <button class="instr-box btn btn-cancel btn-block" (click)="showInstructions()">
              <span>Google Sheet Instructions </span>
              <svg xmlns="http://www.w3.org/2000/svg" width="17.14" height="17.14" viewBox="0 0 17.14 17.14">
                <path id="Icon_awesome-question-circle" data-name="Icon awesome-question-circle"
                      d="M17.7,9.132A8.57,8.57,0,1,1,9.132.563,8.569,8.569,0,0,1,17.7,9.132ZM9.362,3.4A4.476,4.476,0,0,0,5.335,5.6a.415.415,0,0,0,.094.562l1.2.909A.415.415,0,0,0,7.2,7c.617-.783,1.041-1.237,1.98-1.237.706,0,1.579.454,1.579,1.139,0,.518-.427.783-1.124,1.174C8.826,8.529,7.75,9.1,7.75,10.515v.138a.415.415,0,0,0,.415.415H10.1a.415.415,0,0,0,.415-.415v-.046c0-.984,2.875-1.024,2.875-3.686C13.389,4.916,11.31,3.4,9.362,3.4Zm-.23,8.57a1.59,1.59,0,1,0,1.59,1.59A1.591,1.591,0,0,0,9.132,11.966Z"
                      transform="translate(-0.563 -0.563)" fill="#c1c1c1"/>
              </svg>
            </button>
            <button class="btn btn-orange btn-block" (click)="verifyGoogleSheet()">Test Connection & Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="row mt-4" id="instructions" [hidden]="instructions == 'N'">
    <div class="col">
      <div class="inner-box pb-0 pt-4 h-auto">
        <div class="row">
          <div class="col-12">
            <div class="row no-gutters">
              <label>
                <b>Instructions :</b>
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <ul>
                <li>
                  Download the sample excel sheet provided <a
                  href="https://carrier-prod-images.s3.ap-south-1.amazonaws.com/Google-Sheet-Sample-Data.csv" target="_blank">here</a> .
                </li>
                <li>
                  Navigate to google Sheet URL <a href="https://docs.google.com/spreadsheets/" target="_new">here</a>.
                </li>
                <li>
                  Click on "New Blank sheet".
                </li>
                <li>
                  Select the file import option.
                </li>
                <li>
                  Click on share and provided editor access to
                  <strong>"shift-582&#64;shift-349707.iam.gserviceaccount.com"</strong>
                </li>
                <li>
                  Please share the Google sheet Name & sheet ID in the URL.<br>
                  Example : https://docs.google.com/spreadsheets/d/<STRONG placement="bottom"
                                                                           ngbTooltip="Google SheetId"
                                                                           style="text-decoration:underline;">1MvpcACqSjuCebdy1Arb8YNSvjFhb916onNITkpFcyUI</STRONG>/edit#gid=12345
                </li>
                <li>
                  Note: If you have any questions regarding the instructions, feel free to reach out to us. We are
                  always happy to help.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
